import React, { Component } from 'react';




import { apiPut, apiPost, apiGet, apiDelete } from '../../Api';
import StatList from './Admin_Stats_List';
import StatDetail from './Admin_Stats_Detail';
import AdminAPI from './AdminAPI';

export default class Admin_Stats extends Component {


  constructor(props) {
    super(props);
    this.state = {
      stats: [], // Load this from your backend
      enemyTypes: [],

      damageTypes: [],

      creatingNewStat: false,
      selectedStatId: ""
    }
  }




  componentDidMount = async () => {
    this.setState({ stats: await AdminAPI.getStats() });
    this.getEnemyTypes();

    this.getDamageTypes();
  }

  handleSelectStat = (stat) => {

    this.setState({
      selectedStat: stat,
      creatingNewStat: false,
      selectedStatId: stat.id,
    });

  };

  handleNewStat = () => {
    this.setState({
      creatingNewStat: true,
      selectedStat: {},
      selectedStatId: ""
    });
  };


  handleCancelCreate = () => {
    this.setState({
      selectedStat: null,
      creatingNewStat: false,
    });
  };

  handleUpdate = async (stat) => {
    const response = await apiPut("/stat", JSON.stringify(stat));
    if (response.ok) {

      this.setState({ stats: await AdminAPI.getStats() });
      this.setState({ selectedStatId: null });
    }
  };

  handleDelete = async (stat) => {
    // Send delete request to your backend
    const response = await apiDelete("/stat/" + stat.id);
    if (response.ok) {
      this.setState({ stats: await AdminAPI.getStats() });
      this.setState({ selectedStatId: null });
    }
  };

  handleCreate = async (stat) => {
    // Send delete request to your backend
    const response = await apiPost("/stat", JSON.stringify(stat));

    if (response.ok) {
      this.setState({ stats: await AdminAPI.getStats() });
      this.setState({ selectedStatId: null });
    }
    else {
      window.alert(response.text());
    }
  };

  handleSearch = (searchQuery) => {
    // Filter the stats based on search query
  };



  getEnemyTypes = async () => {
    const response = await apiGet("/enemytype");
    if (response.ok) {
      const enemyTypes = await response.json();
      this.setState({ enemyTypes });
    }
  };



  getDamageTypes = async () => {
    const response = await apiGet("/damagetype");
    if (response.ok) {
      const damageTypes = await response.json();
      this.setState({ damageTypes });
    }
  };





  render() {
    const { stats, creatingNewStat } = this.state;

    return (
      <div className="admin-settingspage">
        <StatList
          stats={stats}

          onSelectStat={this.handleSelectStat}
          onSearch={this.handleSearch}
          onNewStat={this.handleNewStat}
        />



        <StatDetail
          creatingNewStat={creatingNewStat}
          statId={this.state.selectedStatId}
          enemyTypes={this.state.enemyTypes}

          damageTypes={this.state.damageTypes}

          onUpdate={this.handleUpdate}
          onDelete={this.handleDelete}
          onCreate={this.handleCreate}
          onCancelCreate={this.handleCancelCreate}
        />

      </div>
    );
  }
}
